import React, { useEffect } from "react";
import "./style.scss";
import AssetIcon from "../asset-icon";
import Arrow from "../../../../assets/PortfolioArrow.svg";
import { getPositionAccrued, IUserBrokerageAccount } from "entities/dashboard";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { AssetType } from "static/types";

type PropType = {
  asset: IUserBrokerageAccount;
  tradePrice: number;
  price: number;
  progress: number;
  onClick: any;
  nonTrading: boolean;
  receivedEarnings?: number;
  nextCouponDate?: string;
  nextCouponValue?: number;
};

export const PortfolioItem: React.FC<PropType> = ({
  tradePrice,
  price,
  progress,
  onClick,
  asset,
  nonTrading,
  receivedEarnings,
  nextCouponDate,
  nextCouponValue,
}) => {
  const { t, i18n } = useTranslation("app");
  const { quantity: count, asset: assetItem } = asset;
  const currency_symbol = assetItem.currency.symbol;

  const symbol = assetItem?.symbol || "";
  const name = assetItem?.name || "";

  const title = name
    ? name.length < 22
      ? name
      : `${name.slice(0, 22)}...`
    : symbol;

  const summaryPnl = +(price * count - tradePrice * count).toFixed(4);

  // Цены и P&L — без НКД: это изменение цены, и сравнивать чистую цену входа
  // с НКД нельзя. А вот сумма позиции в заголовке включает НКД — клиент
  // платил за облигацию вместе с ним, а на купонной дате получит его обратно.
  // Отдельной строкой показываем, сколько именно НКД вошло в сумму.
  const accrued = getPositionAccrued(assetItem, count);

  //todo after UATE release remove isUate checkers
  const isUate = assetItem.symbol === "UATE_CN";

  // useEffect(() => {
  //   console.log(moment().format("HH:mm:ss.SSS"), "asset", symbol, price);
  // }, [symbol, price]);

  const formatNextCouponDate = (date?: string) => {
    if (!date) return "";
    return moment(date, "DD.MM.YYYY").locale(i18n.language).format("MMM D");
  };

  return (
    <div
      className={`portfolio-card ${nonTrading ? "portfolio-promo-card" : ""} ${
        assetItem.symbol === "SPDR" ? "portfolio-spy-promo-card" : ""
      }`.trim()}
      onClick={onClick}
    >
      {nonTrading && <div className="non-trading-background" />}

      <div className="portfolio-card-main-wrapper">
        <AssetIcon asset={assetItem} className="icon" />
        <div className="portfolio-card__main">
          <div className="portfolio-card__top">
            <p>{title}</p>

            <span>
              {+(price * count + accrued).toFixed(2)} {currency_symbol}
            </span>
          </div>

          {!isUate && (
            <div className="portfolio-card__bottom">
              <div>
                <p>
                  {t("qty")}: {+count.toFixed(4)}
                </p>
                <p>
                  {+tradePrice.toFixed(4)}
                  {currency_symbol}
                  <img src={Arrow} alt="Arrow" />
                  {+price.toFixed(4)}
                  {currency_symbol}
                </p>
                {accrued > 0 && <p>({t("withoutACI")})</p>}
              </div>

              {!!summaryPnl && (
                <span
                  className={`${summaryPnl > 0 ? "success" : "danger"} ${
                    assetItem.symbol === "SPDR"
                      ? "spy-promo-pnl-icon-wrapper"
                      : ""
                  }`}
                >
                  {summaryPnl > 0 ? "+" : ""}
                  {summaryPnl}
                  {currency_symbol}{" "}
                  {!!progress && (
                    <>
                      ({progress > 0 ? "+" : ""}
                      {progress}%)
                    </>
                  )}
                </span>
              )}
            </div>
          )}

          {accrued > 0 && (
            <div className="portfolio-card__accrued">
              <p>{t("ACI")}</p>
              <span>
                +{accrued}
                {currency_symbol}
              </span>
            </div>
          )}

          {assetItem.symbol === "SPDR" && (
            <>
              <div className="portfolio-card__bottom">
                <div>
                  <p>
                    {t("tradeDate")}: {moment(asset.date).format("DD.MM.YYYY")}
                  </p>
                </div>
              </div>
              {asset?.data?.protection_date && (
                <div className="portfolio-card__bottom">
                  <div>
                    <p>
                      {t("protectionDate")}:{" "}
                      {moment(asset.data.protection_date)
                        .add(1, "month")
                        .format("DD.MM.YYYY")}
                    </p>
                  </div>
                </div>
              )}

              <p className="spy-icon-text">{t("100%Protection")}</p>
            </>
          )}
        </div>
      </div>

      {(receivedEarnings || nextCouponDate) && <hr />}
      {(receivedEarnings || nextCouponDate) && (
        <div className="portfolio-card__coupon">
          <p>
            {assetItem.type === AssetType.Bond ||
            assetItem.type === AssetType.EuroBond
              ? t("couponsReceived")
              : t("dividendsReceived")}
            <span style={{ color: receivedEarnings ? "#1e734a" : "#a9b1c4" }}>
              {receivedEarnings ? `+${receivedEarnings}` : 0}
              {currency_symbol}
            </span>
          </p>
          {nextCouponDate && (
            <span>
              {t("next")}: {formatNextCouponDate(nextCouponDate)}
              <b style={{ marginLeft: "6px" }}>
                {nextCouponValue && nextCouponValue * count}
                {currency_symbol}
              </b>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

// {/* {nonTrading && (
//   <div className="not-sellable">
//     <img src={NotSellable} alt="NotSellable" />

//     <div className="not-sellable-popup-wrapper">
//       <div className="not-sellable-popup">{t("notSellable")}</div>
//     </div>
//   </div>
// )} */}

// import ProgressUp from "../../../../assets/BalanceUp.svg";
// import ProgressDown from "../../../../assets/BalanceDown.svg";
// import NotSellable from "../../../../assets/NotSellable.svg";
// import usePrice from "hooks/usePrice";
// import useExchangeTimeFrame from "hooks/useExchangeTimeFrame";

// const exchange = useExchangeTimeFrame(assetItem?.exchange);

// const { last, mid } = usePrice({
//   exchangeStatus: exchange?.status,
//   exchange: exchange?.exchange_code,
//   symbol: assetItem?.symbol,
//   assetType: assetItem?.type,
//   ask: assetItem?.ask,
//   bid: assetItem?.bid,
//   price: assetItem?.price,
// });

// <AssetIcon asset={assetItem} className="icon" />
// <span>{assetItem.symbol}</span>

// <div className="item-progress">
// <p>
//   {+count.toFixed(4)} <b>•</b> {+price.toFixed(4)}
//   {currency_symbol}
// </p>
// {!!progress && (
//   <span className={progress < 0 ? "danger" : ""}>{progress}%</span>
// )}
// </div>
// <p>{+tradePrice.toFixed(4)} {">"} {+price.toFixed(4)}</p>
// <p>Qty: {+count.toFixed(4)}</p>

//  <div className="details-item">
//   <p>Quantity:</p>
//   <span>{+count.toFixed(4)}</span>
// </div>
// <div className="details-item">
//   <p>Buy price:</p>
//   <span>
//     {+tradePrice.toFixed(4)}
//     {currency_symbol}
//   </span>
// </div>
// <div className="details-item">
//   <p>Market price:</p>
//   <span>
//     {+price.toFixed(4)}
//     {currency_symbol}
//   </span>
// </div>

// {!!progress && (
//     <div className="details-item">
//       <p>PnL %:</p>
//       <span className={progress < 0 ? "danger" : "success"}>
//         {progress > 0 ? "+" : ""}
//         {progress}%
//       </span>
//     </div>
// )}
